import React, { useState } from 'react';
import FolderIcon from '../components/folderIcon';

const CollectiblesPage = ({ theme, folders, onFolderClick, onBackClick }) => {
  const [hoveredFolder, setHoveredFolder] = useState(null);

  return (
    <div className='collectiblesPage'>
      <h3>Collecting Things</h3>
      <p>I enjoy collecting things, this is to help catalogue them.</p>
      <div className="folderChoices">
        {folders.map((folder) => (
          <div
            key={folder.id}
            onMouseEnter={() => setHoveredFolder(folder.id)}
            onMouseLeave={() => setHoveredFolder(null)}
          >
            <FolderIcon
              theme={theme}
              label={folder.label}
              isHovered={hoveredFolder === folder.id}
              onClick={() => onFolderClick(folder.id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CollectiblesPage;